import React from 'react';
import { Target, Users, Globe, Award, Building } from 'lucide-react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import CTA from '../components/sections/CTA';

const AboutPage = () => {
  const partners = ['We Advise', 'CIBA Congress', 'COSMOS 3D', 'MODE Modular'];

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <section className="relative pt-40 pb-24 bg-neutral-950 overflow-hidden">
          <div className="absolute inset-0 opacity-20">
            <div className="absolute inset-0" style={{
              backgroundImage: 'linear-gradient(to right, white 1px, transparent 1px), linear-gradient(to bottom, white 1px, transparent 1px)',
              backgroundSize: '60px 60px'
            }} />
          </div>
          <div className="relative z-10 max-w-7xl mx-auto px-6">
            <div className="max-w-3xl">
              <span className="text-red-500 text-sm font-semibold uppercase tracking-wider">Sobre Nosotros</span>
              <h1 className="text-5xl md:text-6xl font-bold text-white mt-4 mb-6">
                Transformando la
                <span className="block text-red-500">Construcción en LATAM</span>
              </h1>
              <p className="text-xl text-neutral-400 leading-relaxed">We Develop opera como integrador y partner comercial, con capacidad de originar deals a través de We Advise y el Congreso CIBA.</p>
            </div>
          </div>
        </section>

        <section className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid lg:grid-cols-2 gap-16">
              <div className="relative">
                <div className="sticky top-32">
                  <img src="https://images.unsplash.com/photo-1653271827655-090279078f29?w=800&auto=format&fit=crop" alt="Modular Construction" className="rounded-3xl shadow-2xl" />
                </div>
              </div>
              <div className="space-y-12">
                <div>
                  <div className="w-14 h-14 rounded-xl bg-red-100 flex items-center justify-center mb-4">
                    <Target className="text-red-600" size={28} />
                  </div>
                  <h2 className="text-3xl font-bold text-neutral-900 mb-4">Nuestra Misión</h2>
                  <p className="text-neutral-600 leading-relaxed">Traer a Latinoamérica las mejores tecnologías de construcción industrializada: impresión 3D de hormigón y construcción modular premium.</p>
                </div>
                <div>
                  <div className="w-14 h-14 rounded-xl bg-red-100 flex items-center justify-center mb-4">
                    <Globe className="text-red-600" size={28} />
                  </div>
                  <h2 className="text-3xl font-bold text-neutral-900 mb-4">Alcance Regional</h2>
                  <p className="text-neutral-600 leading-relaxed">Operamos principalmente en Argentina y Uruguay, con planes de expansión regional.</p>
                </div>
                <div>
                  <div className="w-14 h-14 rounded-xl bg-red-100 flex items-center justify-center mb-4">
                    <Award className="text-red-600" size={28} />
                  </div>
                  <h2 className="text-3xl font-bold text-neutral-900 mb-4">Estándares de Calidad</h2>
                  <p className="text-neutral-600 leading-relaxed">Trabajamos bajo estándares europeos, con tecnología probada en los mercados más exigentes.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-24 bg-neutral-50">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <span className="text-red-600 text-sm font-semibold uppercase tracking-wider">Nuestra Red</span>
              <h2 className="text-4xl md:text-5xl font-bold text-neutral-900 mt-4">Ecosistema We Develop</h2>
            </div>
            <div className="grid md:grid-cols-3 gap-8">
              {[
                { icon: Building, title: 'We Develop', description: 'Integrador y partner comercial para proyectos de construcción industrializada.' },
                { icon: Users, title: 'We Advise', description: 'Consultoría especializada y originación de deals para inversores.' },
                { icon: Globe, title: 'Congreso CIBA', description: 'Plataforma de networking y originación de negocios.' }
              ].map((item, index) => {
                const Icon = item.icon;
                return (
                  <div key={index} className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-shadow">
                    <div className="w-14 h-14 rounded-xl bg-red-50 flex items-center justify-center mb-4">
                      <Icon className="text-red-600" size={28} />
                    </div>
                    <h3 className="text-xl font-bold text-neutral-900 mb-2">{item.title}</h3>
                    <p className="text-neutral-600">{item.description}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <section className="py-16 bg-neutral-950">
          <div className="max-w-7xl mx-auto px-6">
            <p className="text-neutral-500 text-sm mb-8 text-center">Con el apoyo de:</p>
            <div className="flex flex-wrap justify-center gap-12">
              {partners.map((partner, index) => (
                <span key={index} className="text-neutral-400 text-lg font-medium hover:text-white transition-colors cursor-default">{partner}</span>
              ))}
            </div>
          </div>
        </section>

        <CTA />
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;
